import {
  useFloating as useFloatingCore,
  offset,
  flip,
  shift,
  size,
  autoUpdate,
  type Placement,
} from '@floating-ui/vue'
import type { Ref } from 'vue'

// The single positioning engine (contract 02 §9, ledger B11). Replaces the duplicated
// hand-rolled getBoundingClientRect logic that lived in OrphexTooltip + OrphexCustomSelect.
export interface UseFloatingOptions {
  placement?: Placement
  offset?: number
  flip?: boolean
  strategy?: 'absolute' | 'fixed'
}

export function useFloating(
  reference: Ref<HTMLElement | null>,
  floating: Ref<HTMLElement | null>,
  options: UseFloatingOptions = {},
) {
  return useFloatingCore(reference, floating, {
    placement: options.placement ?? 'bottom',
    strategy: options.strategy ?? 'absolute',
    middleware: [
      offset(options.offset ?? 6),
      ...(options.flip === false ? [] : [flip()]),
      shift({ padding: 6 }),
      size({
        padding: 6,
        apply({ availableWidth, availableHeight, elements, rects }) {
          elements.floating.style.setProperty(
            '--ui-floating-reference-width',
            `${Math.max(0, rects.reference.width)}px`,
          )
          elements.floating.style.setProperty(
            '--ui-floating-available-width',
            `${Math.max(0, availableWidth)}px`,
          )
          elements.floating.style.setProperty(
            '--ui-floating-available-height',
            `${Math.max(0, availableHeight)}px`,
          )
        },
      }),
    ],
    whileElementsMounted: autoUpdate,
  })
}
